import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'opportunities.title',
    defaultMessage: 'Opportunities',
  },
  acceptAll: {
    id: 'opportunities.recommendation.accept-all',
    defaultMessage: 'Accept all opportunities',
  },
  addSpotsTabTitle: {
    id: 'opportunities.recommendation.add-spots-tab-title',
    defaultMessage: 'Add spots',
  },
  enableClassesTabTitle: {
    id: 'opportunities.recommendation.enable-classes-tab-title',
    defaultMessage: 'Enable classes',
  },
  spotsTitle: {
    id: 'opportunities.recommendation.spots-title',
    defaultMessage: 'Add more ClassPass spots to maximize your total revenue.',
  },
  spotsBiline: {
    id: 'opportunities.recommendation.spots-biline',
    defaultMessage: 'Recommended spot changes are projected based on your historical fill rate and member demand.',
  },
  classesTitle: {
    id: 'opportunities.recommendation.classes-title',
    defaultMessage: 'These classes are currently not available to ClassPass members.',
  },
  classesBiline: {
    id: 'opportunities.recommendation.classes-biline',
    defaultMessage: 'Enable them to get more bookings.',
  },
  dayAndDate: {
    id: 'opportunities.row.day-and-medium-date',
    defaultMessage: '{day}, {date, date, medium-no-year}',
  },
  xOfy: {
    id: 'opportunities.row.x-of-y',
    defaultMessage: '{x, number} of {y, number}',
  },
  addBtn: {
    id: 'opportunities.row.add-btn',
    defaultMessage: 'Add {spots, plural, one {# spot} other {# spots}}',
  },
  enableBtn: {
    id: 'opportunities.row.enable-btn',
    defaultMessage: 'Enable with {spots, plural, one {# spot} other {# spots}}',
  },
  enableBtnPlus: {
    id: 'opportunities.row.enable-btn-plus',
    defaultMessage: 'Enable class + {spots, plural, one {# spot} other {# spots}}',
  },
  pricingOptionIssue: {
    id: 'opportunities.row.class-disabled-pricing-issue',
    defaultMessage:
      'To make this class visible and begin receiving bookings, update the <a>MINDBODY Pricing Option</a> for this class in your MINDBODY console and then enable this class.',
  },
  earningPrediction: {
    id: 'opportunities.row.earning-prediction',
    defaultMessage:
      'ClassPass predicts you’ll fill {spots, plural, one {# more spot} other {# more spots}} in this class.',
  },
  fillPrediction: {
    id: 'opportunities.row.fill-prediction',
    defaultMessage:
      'By listing this class on ClassPass, you could fill {spots, plural, one {# more spot} other {# spots}}.',
  },
  allBookings: {
    id: 'opportunities.row.all-bookings',
    defaultMessage: 'All Bookings',
  },
  cp: {
    id: 'opportunities.row.cp',
    defaultMessage: 'CP',
  },
  split: {
    id: 'opportunities.row.split',
    defaultMessage: '{numerator, number} / {denominator, number}',
  },
  checkboxLabel: {
    id: 'opportunities.row.checkbox-label',
    defaultMessage: 'This and all upcoming instances',
  },
  smartSpotWaitingClients: {
    id: 'opportunities.row.smart-spot-waiting-clients',
    defaultMessage:
      '<strong>{clients, plural, =0 {Clients} one {# client} other {# clients}}</strong> {clients, plural, =0 {are} one {is} other {are}} waiting to be notified when spots open up',
  },
  smartSpotProtecting: {
    id: 'opportunities.row.smart-spot-protecting',
    defaultMessage: 'SmartSpot is protecting your direct demand',
  },
  smartSpotProtectingSubheading: {
    id: 'opportunities.row.smart-spot-protecting-subheading',
    defaultMessage: 'SmartSpot is protecting your direct demand.',
  },
  smartSpotMaximize: {
    id: 'opportunities.row.smart-spot-maximize',
    defaultMessage: 'Open this class to more bookings to maximize your class revenue.',
  },
});

export const integrationsBannerMessages = defineMessages({
  title: {
    id: 'opportunities.integrations-banner.title',
    defaultMessage: 'Explore ClassPass booking platform integrations',
  },
  subtitle: {
    id: 'opportunities.integrations-banner.subtitle',
    defaultMessage:
      'ClassPass integrates with 80+ fitness & wellness booking systems so you can easily manage your schedule and maximize your revenue.',
  },
  ctaButton: {
    id: 'opportunities.integrations-banner.cta-button',
    defaultMessage: 'See all integrations',
  },
});
